import { api } from './api'

export const updateProfile = (admin) => api.put('/profile', admin)
export const updateProfilePassword = (password) => api.put('/profile/password', { password })
